import type { CSSProperties, FC } from 'react';

import backgroundArtSource from './streamlain-background-art.json';

export interface StreamLainBackgroundArtPathSource {
  d: string;
  fillRule?: 'evenodd' | 'nonzero';
  clipRule?: 'evenodd' | 'nonzero';
}

export interface StreamLainBackgroundArtAssetSource {
  id: string;
  paths: StreamLainBackgroundArtPathSource[];
}

export interface StreamLainBackgroundArtSource {
  width: number;
  height: number;
  viewBox: string;
  topOffsetPx: number;
  primary: string;
  pathFilter: string;
  assets: StreamLainBackgroundArtAssetSource[];
}

export const STREAMLAIN_BACKGROUND_ART =
  backgroundArtSource as StreamLainBackgroundArtSource;

export const STREAMLAIN_BACKGROUND_ART_BOOT_GEOMETRY_STYLE = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  zIndex: 0,
  width: 'min(100vw, 1920px)',
  height: 'min(100dvh, 1080px)',
  overflow: 'visible',
  pointerEvents: 'none',
  transform: 'translate(-50%, -50%)',
} satisfies CSSProperties;

export interface StreamLainBackgroundArtProps {
  className?: string;
  color?: string;
  pathFilter?: string;
  style?: CSSProperties;
}

export const StreamLainBackgroundArt: FC<StreamLainBackgroundArtProps> = ({
  className,
  color = 'currentColor',
  pathFilter = STREAMLAIN_BACKGROUND_ART.pathFilter,
  style,
}) => {
  return (
    <svg
      className={className}
      width={STREAMLAIN_BACKGROUND_ART.width}
      height={STREAMLAIN_BACKGROUND_ART.height}
      viewBox={STREAMLAIN_BACKGROUND_ART.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      style={style}
    >
      {STREAMLAIN_BACKGROUND_ART.assets.map(asset => (
        <g key={asset.id} data-sl-background-art={asset.id}>
          {asset.paths.map((path, index) => (
            <path
              key={`${asset.id}-${index}`}
              d={path.d}
              fill={color}
              fillRule={path.fillRule}
              clipRule={path.clipRule}
              style={{ filter: pathFilter }}
            />
          ))}
        </g>
      ))}
    </svg>
  );
};
